// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__aRnie","messageAnimation":"message_messageAnimation__3ISpa","messageAlert":"message_messageAlert__37tUe"};